module.exports = __webpack_public_path__ + "img/zizhi11.76fd7a16.png";